import React from 'react';
import { Pin } from 'lucide-react';
import { TrendBadge } from './TrendBadge';
import { SparklineChart } from './SparklineChart';
import { SkeletonLoader } from './SkeletonLoader';

export function MetricCard({ title, value, trend, sparklineData, loading, pinned, onPin, color = '#3B82F6' }) {
  if (loading) return <SkeletonLoader variant="card" />;

  return (
    <div className={`glass-card rounded-2xl p-4 lg:p-5 hover-lift relative group transition-all duration-200 h-full ${
      pinned ? 'ring-2 ring-blue-400/30' : ''
    }`}>
      {/* Pin toggle */}
      {onPin && (
        <button
          onClick={onPin}
          className={`absolute top-3 right-3 p-1 rounded-lg transition-all ${
            pinned
              ? 'text-blue-500 bg-blue-50'
              : 'text-gray-300 hover:text-gray-500 opacity-0 group-hover:opacity-100'
          }`}
        >
          <Pin size={12} className={pinned ? 'fill-current' : ''} />
        </button>
      )}

      <p className="text-[10px] uppercase tracking-wider text-gray-400 font-semibold mb-2">{title}</p>
      <p className="text-xl lg:text-2xl font-bold text-gray-900 mb-1.5 leading-tight">{value}</p>

      <div className="flex items-end justify-between gap-2">
        <div>
          {trend != null && <TrendBadge value={trend} />}
        </div>
        {sparklineData && sparklineData.length > 0 && (
          <div className="w-16 lg:w-20 flex-shrink-0 opacity-70">
            <SparklineChart data={sparklineData} color={color} height={28} />
          </div>
        )}
      </div>
    </div>
  );
}
